// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".new_home_div{color:#212529}.new_home_div>>>.modal-header{border:none!important;padding:0 .05rem!important}.new_home_div>>>.modal-footer{display:none}.new_home_div>>>.modal-body{padding:0 .2rem .1rem!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
